import React from 'react';
import DepartmentTopResearcherCard from '@/features/department/components/DepartmentTopResearcherCard';

function yearRangeLabel(startYear, endYear) {
    if (startYear == null || endYear == null) return null;
    return startYear === endYear ? `(${startYear})` : `(${startYear}-${endYear})`;
}

export default function DepartmentMostCitedResearcherCard({ deptId, startYear, endYear }) {
    return (
        <DepartmentTopResearcherCard
            title="Most Cited Researcher"
            yearRangeLabel={yearRangeLabel(startYear, endYear)}
            deptId={deptId}
            startYear={startYear}
            endYear={endYear}
            endpoint={deptId ? `/rm/v1/department/${deptId}/top_cited` : "/rm/v1/department/top_cited"}
        />
    );
}

